'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../ui/tooltip';
import { SpecraText } from '../ensigns/typography';
const SpecraTooltipProviderContext = /*#__PURE__*/ React.createContext(false);
/** Shared provider for tooltip groups; enables skip-delay behavior across adjacent triggers. */ export function SpecraTooltipProvider({ children, ...props }) {
    return /*#__PURE__*/ _jsx(SpecraTooltipProviderContext.Provider, {
        value: true,
        children: /*#__PURE__*/ _jsx(TooltipProvider, {
            ...props,
            children: children
        })
    });
}
/** Accessible, tokenized tooltip matching the restrained prototype treatment. */ export function SpecraTooltip({ children, className, content, contentProps, delayDuration = 300, placement = 'top', portalContainer, providerProps }) {
    const hasSharedProvider = React.useContext(SpecraTooltipProviderContext);
    const tooltip = /*#__PURE__*/ _jsxs(Tooltip, {
        delayDuration: delayDuration,
        children: [
            /*#__PURE__*/ _jsx(TooltipTrigger, {
                asChild: true,
                children: children
            }),
            /*#__PURE__*/ _jsx(TooltipContent, {
                ...contentProps,
                className: cn('rounded-[var(--radius-sm)] bg-[var(--tooltip-background)] px-[var(--space-2)] py-[var(--space-1)] text-[var(--tooltip-foreground)] shadow-[var(--shadow-md)]', contentProps?.className, className),
                portalContainer: portalContainer,
                side: placement,
                children: /*#__PURE__*/ _jsx(SpecraText, {
                    className: "text-inherit",
                    size: "meta",
                    children: content
                })
            })
        ]
    });
    if (hasSharedProvider) return tooltip;
    return /*#__PURE__*/ _jsx(TooltipProvider, {
        delayDuration: delayDuration,
        ...providerProps,
        children: tooltip
    });
}
